import { useCallback, useMemo } from 'react';

/**
 * Hook to manage grid, snap guides, and positioning-related handlers
 * Used for keyboard shortcuts and positioning controls
 */
function usePositioningHandlers({
  showGrid,
  setShowGrid,
  showSnapGuides,
  setShowSnapGuides,
  setSnapLines,
  gridSize,
  setGridSize,
  actions
}) {
  const handleToggleGrid = useCallback(() => {
    setShowGrid(!showGrid);
  }, [showGrid, setShowGrid]);

  const handleToggleSnapGuides = useCallback(() => {
    setShowSnapGuides(!showSnapGuides);
    if (!showSnapGuides) {
      setSnapLines([]);
    }
  }, [showSnapGuides, setShowSnapGuides, setSnapLines]);

  const handleGridSizeChange = useCallback((newSize) => {
    setGridSize(newSize);
  }, [setGridSize]);

  // Keyboard shortcuts configuration
  const keyboardHandlers = useMemo(() => ({
    toggleGrid: handleToggleGrid,
    toggleSnapGuides: handleToggleSnapGuides,
    alignLeft: actions.handleAlignLeft,
    alignCenter: actions.handleAlignCenter,
    alignRight: actions.handleAlignRight,
    alignTop: actions.handleAlignTop,
    alignMiddle: actions.handleAlignMiddle,
    alignBottom: actions.handleAlignBottom,
    distributeHorizontally: actions.handleDistributeHorizontally,
    distributeVertically: actions.handleDistributeVertically,
    selectAll: actions.selectAll,
    clearSelection: actions.clearSelection,
    deleteSelected: actions.deleteSelected,
    nudge: actions.handleNudge,
    undo: actions.undoAction,
    redo: actions.redoAction
  }), [
    handleToggleGrid,
    handleToggleSnapGuides,
    actions
  ]);

  return {
    handleToggleGrid,
    handleToggleSnapGuides,
    handleGridSizeChange,
    keyboardHandlers
  };
}

export default usePositioningHandlers;
